export const VALIDATION_ERROR_CLASS = "wsata-field-error";

const FIELD_ID_ALIASES = {
  possible_to_sell_to_customer_no: "possible_to_sell_to_customer",
};

/** @type {import('vuex').Store | null} */
let activeValidationStore = null;
let globalClearListenersInstalled = false;

export const DEFAULT_KNOWN_FIELD_IDS = [
  "request_id",
  "rejection_id_agent",
  "rejection_id_cs",
  "class_id_cs",
  "class_id_agent",
  "jointobligations_value",
  "possible_to_sell_to_customer",
  "possible_to_sell_to_customer_no",
  "funding_source",
  "fundDur",
  "fundPersPre",
  "fundReal",
  "fundRealPre",
  "fundMonth",
  "realType",
  "realCity",
  "bank_notes",
  "reqtyp",
  "req_product_type",
  "has_property",
  "owning_property",
  "comment",
  "customer_service_note",
  "customer_needs_id",
  "objections_challenges_id",
  "obstacles_id",
  "class_agent",
  "agent_notes",
  "quacomment",
  "follow_date",
  "follow_time",
];

export function resolveFieldId(fieldKey) {
  return FIELD_ID_ALIASES[fieldKey] || fieldKey;
}

function findFieldRoot(node) {
  let element = node;
  while (element) {
    if (element.id) {
      return element;
    }
    element = element.parentElement;
  }
  return null;
}

function removeFieldFromStore(fieldId, store = activeValidationStore) {
  if (!store?.state?.arrayOfErrors) {
    return;
  }

  const resolvedId = resolveFieldId(fieldId);
  store.state.arrayOfErrors = store.state.arrayOfErrors.filter(
    (key) => resolveFieldId(key) !== resolvedId
  );
}

export function clearSingleFieldError(fieldId, store = activeValidationStore) {
  clearFieldHighlight(fieldId);
  removeFieldFromStore(fieldId, store);
}

function handleValidationFieldInteraction(event) {
  if (event.type === "input" || event.type === "change") {
    const fieldRoot = event.target.closest(`.${VALIDATION_ERROR_CLASS}`);
    if (fieldRoot?.id) {
      clearSingleFieldError(fieldRoot.id);
    }
    return;
  }

  if (event.type !== "click") {
    return;
  }

  const listItem = event.target.closest(".v-list-item");
  if (listItem && event.target.closest(".v-menu__content")) {
    const activeSelect = document.querySelector(
      ".v-select.v-select--is-menu-active, .v-autocomplete.v-select--is-menu-active"
    );
    if (!activeSelect) {
      return;
    }

    const fieldRoot = findFieldRoot(activeSelect);
    if (fieldRoot?.classList.contains(VALIDATION_ERROR_CLASS)) {
      clearSingleFieldError(fieldRoot.id);
    }
    return;
  }

  const datePickerCell = event.target.closest(
    ".v-date-picker-table button, .v-picker__body button, .v-time-picker-clock__item"
  );
  if (datePickerCell) {
    const activePicker = document.querySelector(
      ".v-input.v-input--is-focused, .v-input.v-input--is-label-active"
    );
    if (!activePicker) {
      return;
    }

    const fieldRoot = findFieldRoot(activePicker);
    if (fieldRoot?.classList.contains(VALIDATION_ERROR_CLASS)) {
      clearSingleFieldError(fieldRoot.id);
    }
  }
}

function installGlobalClearListeners() {
  if (globalClearListenersInstalled) {
    return;
  }

  globalClearListenersInstalled = true;
  document.addEventListener("input", handleValidationFieldInteraction, true);
  document.addEventListener("change", handleValidationFieldInteraction, true);
  document.addEventListener("click", handleValidationFieldInteraction, true);
}
export function normalizeErrorFields(errorFields) {
  if (!Array.isArray(errorFields)) {
    return [];
  }

  const normalized = errorFields.map((key) => resolveFieldId(key));
  return [...new Set(normalized)];
}

export function highlightField(fieldId) {
  const element = document.getElementById(resolveFieldId(fieldId));
  if (!element) {
    return false;
  }

  element.classList.add(VALIDATION_ERROR_CLASS);
  return true;
}

export function clearFieldHighlight(fieldId) {
  const element = document.getElementById(resolveFieldId(fieldId));
  if (!element) {
    return;
  }

  element.classList.remove(VALIDATION_ERROR_CLASS);
}

export function clearAllFieldHighlights(fieldIds = DEFAULT_KNOWN_FIELD_IDS) {
  (fieldIds || []).forEach(clearFieldHighlight);
}

export function applyValidationErrors(errorFields, store, knownFieldIds = DEFAULT_KNOWN_FIELD_IDS) {
  activeValidationStore = store;
  installGlobalClearListeners();
  clearAllFieldHighlights(knownFieldIds);
  const fields = normalizeErrorFields(errorFields);
  if (store?.state) {
    store.state.arrayOfErrors = [...fields];
  }

  fields.forEach(highlightField);

  const firstVisible = fields.find((fieldId) => document.getElementById(fieldId));
  if (firstVisible) {
    document.getElementById(firstVisible).scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }

  return fields;
}

export function handleRequestSaveValidationError(err, vm, options = {}) {
  const {
    knownFieldIds = DEFAULT_KNOWN_FIELD_IDS,
    validationDialogCode = 402,
  } = options;

  const data = err?.response?.data;
  if (!data) {
    return false;
  }

  if (data.code == validationDialogCode) {
    vm.$store.state.ValidationAsDialog = true;
    vm.$store.state.ValidationAsDialogMessage = data.message;
    applyValidationErrors(data.array, vm.$store, knownFieldIds);
    return true;
  }

  if (Array.isArray(data.message)) {
    vm.showPopupError("error", data.message);
  } else if (typeof data.message === "string") {
    vm.showPopup("error", data.message);
  } else if (data.message?.[0]) {
    const messages =
      typeof data.message[0] === "string"
        ? data.message[0].split(",")
        : data.message;
    vm.showPopupError("error", messages);
  }

  if (Array.isArray(data.array) && data.array.length) {
    applyValidationErrors(data.array, vm.$store, knownFieldIds);
  }

  return true;
}
